import { useRef, useContext, useEffect, forwardRef } from "react";
import { useStyle } from "lib/hooks";
import iro from "@jaames/iro";
import { classnames } from "lib/helpers";
import { TreeContext } from "pages/Editor";

/**
 * attr need not be present
 * attr checks have been added to prevent setting unwanted colors
 * without attr, you'll have to reset colorpicker from outside
 */
function ColorPicker({ attr, onChange, s, placeholder }, _ref) {
  const ref = useRef();
  const { selection } = useContext(TreeContext);
  const [style, setStyle] = useStyle(attr);
  const onClick = () => {
    ref.current.style.display = "block";
  };
  useEffect(() => {
    // make sure target ref is present
    // if (selection) {
    // TODO: rename cp
    const options = {
      width: 256,
    };
    if (attr) options.color = style;
    const _cp = new iro.ColorPicker(ref.current, options);
    // replace style with null in case undefined because undefined does nothing
    if (attr) ref.current.parentNode.style.background = style || null;
    _cp.on("color:change", () => {
      const color = _cp.color.hexString;
      if (attr) setStyle(color, false);
      ref.current.parentNode.style.background = color;
    });
    // not really used
    _cp.on("color:remove", () => {
      ref.current.parentNode.style.background = null;
    });
    _cp.on("input:end", () => {
      const color = _cp.color.hexString;
      if (onChange) onChange();
      if (attr) setStyle(color);
      ref.current.style.display = "none";
    });
    const listener = ({ target }) => {
      if (!ref.current.parentNode.contains(target)) {
        ref.current.style.display = "none";
      }
    };
    if (_ref) _ref.current = _cp;
    window.addEventListener("click", listener);
    return () => {
      _cp.el.removeChild(_cp.base);
      _cp.el = null;
      window.removeEventListener("click", listener);
      if (_ref) _ref.current = null;
    };
    // }
  }, [_ref, onChange, attr, style, setStyle]);
  // close when selection changes
  useEffect(() => {
    ref.current.style.display = "none";
  }, [selection]);
  return (
    <div className={classnames("vc cp", { s })} {...{ onClick }}>
      <div className="t">{placeholder}</div>
      <div {...{ ref }} style={{ display: "none" }} className="cp"></div>
    </div>
  );
}

export default forwardRef(ColorPicker);
